
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/list-of-authorised-persons",
      function () {
        return require("private-next-pages/compliance/list-of-authorised-persons/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/list-of-authorised-persons"])
      });
    }
  